import Dashboard from "./pages/Dashboard";
import Logo from "./components/Logo";

const MainApp = ({ onLogout }) => {
  return (
    <div className="main-app-container">
      <div className="app-header-bar" style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        padding: "20px 32px",
        background: "var(--white)",
        boxShadow: "var(--shadow)",
        borderBottom: "3px solid var(--primary-coral)"
      }}>
        {/* Logo with actual pflegehelden logo
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{
            width: "40px",
            height: "40px",
            background: "linear-gradient(135deg, var(--primary-coral), var(--accent-coral))",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--white)",
            fontWeight: "bold",
            fontSize: "18px"
          }}>
            💖
          </div>
          <h1 style={{ 
            margin: 0, 
            color: "var(--primary-coral)",
            fontSize: "28px",
            fontWeight: "700",
            marginLeft: "16px"
          }}>
            pflegehelden
          </h1>
        </div> */}
        <Logo size="medium" showText={true} />
        
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <span style={{ 
            color: "var(--text-light)",
            fontSize: "14px"
          }}>
            Demo App
          </span>
          <button 
            onClick={onLogout}
            style={{
              background: "var(--primary-coral)",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            🔒 Logout
          </button>
        </div>
      </div>

      <Dashboard />
    </div>
  );
};

export default MainApp;
